function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 370.15,
  y1: 53.81,
  x2: 399.6,
  y2: 161.23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0a7982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#0a7982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#00a79d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#5ba982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#56a983"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#37a88d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#1fa894"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#0ea799"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#03a79c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#00a79d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#08a99b",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#20af95",
  stopOpacity: 0.92
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#47b98c",
  stopOpacity: 0.82
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#74c481",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 370.15,
  y1: 53.81,
  x2: 399.6,
  y2: 161.23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0a7982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#0a7982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#127b82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#0e8689",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#00a79d",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#5ba982",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#67b682",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#71c181",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#74c481",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#74c481"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 403.64,
  y1: 109.27,
  x2: 460.95,
  y2: 49.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00a79d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#74c481",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#74c481",
  stopOpacity: 0.9
})), /*#__PURE__*/React.createElement("style", null, "\n      .cls-2{fill:#a0cf6a}.cls-3{fill:#231f20}.cls-4{fill:url(#linear-gradient)}.cls-7{fill:#9ac96c}\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M480.9 150.44H370.19a7.24 7.24 0 01-7.19-7.24V32.49a7.24 7.24 0 017.24-7.24H480.9a7.25 7.25 0 017.24 7.24V143.2a7.25 7.25 0 01-7.24 7.24zm-109.12-8.83h107.53V34.08H371.78z",
  opacity: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M409 116.31v39.58h-27.74V.14H409v116.17zM419.55 114.13l17.14-20.38 41.51 62.19h-32.46z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M411.45 123.76c-2.37 2.73-4.7 5.51-7.13 8.19a16.44 16.44 0 01-26.76-3.29c-2.55-4.65-5-9.38-7.5-14-2.31-4.21-4.53-8.47-6.79-12.7-1.2-2.24-2.38-4.5-3.56-6.75a14.09 14.09 0 01-1.63-6.7 14.38 14.38 0 0126.39-7.89q5.17 7.62 10.33 15.26"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M411.45 123.76c-2.37 2.73-4.7 5.51-7.13 8.19a16.44 16.44 0 01-26.76-3.29c-2.55-4.65-5-9.38-7.5-14-2.31-4.21-4.53-8.47-6.79-12.7-1.2-2.24-2.38-4.5-3.56-6.75a14.09 14.09 0 01-1.63-6.7 14.38 14.38 0 0126.39-7.89q5.17 7.62 10.33 15.26"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M411.45 123.76c-2.37 2.73-4.7 5.51-7.13 8.19a16.44 16.44 0 01-26.76-3.29c-2.55-4.65-5-9.38-7.5-14-2.31-4.21-4.53-8.47-6.79-12.7-1.2-2.24-2.38-4.5-3.56-6.75a14.09 14.09 0 01-1.63-6.7 14.38 14.38 0 0126.39-7.89q5.17 7.62 10.33 15.26",
  fill: "url(#linear-gradient-3)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M394.8 95.84c.45.67.45.66 1.05.13l13.26-11.65 12.05-10.63c3.47-3.07 6.92-6.16 10.44-9.17a12 12 0 0115.06 0A11.84 11.84 0 01449 80.38a38.47 38.47 0 01-3 3.68q-5.38 6.22-10.8 12.42l-10.66 12.22-13.09 15.06",
  fill: "url(#linear-gradient-4)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 460.7,
  cy: 52.25,
  r: 10.49
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 481.86,
  cy: 30.34,
  r: 9.02
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-7",
  cx: 503.33,
  cy: 9.65,
  r: 8.09
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M340.29 35.19q7.54 0 12.15-4.34a14.68 14.68 0 004.61-11.17 14.63 14.63 0 00-4.55-11.07q-4.56-4.35-12.21-4.35T328 8.61a14.7 14.7 0 00-4.5 11.07 14.67 14.67 0 004.6 11.17q4.64 4.35 12.19 4.34z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M325.79 47.53h29V155.9h-29z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M99.08 35.19q7.69 0 12.39-4.34a14.54 14.54 0 004.7-11.17 14.47 14.47 0 00-4.65-11.07q-4.63-4.35-12.44-4.35T86.57 8.61A14.56 14.56 0 0082 19.68a14.54 14.54 0 004.7 11.17q4.68 4.35 12.38 4.34z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M84.29 47.53h29.58V155.9H84.29zM287.61 20.67v27H306v19.77h-18.39v55.8c0 3.73.71 6.41 2.14 8s4.17 2.43 8.21 2.43a56.76 56.76 0 009-.65v20.43a62.76 62.76 0 01-17.4 2.42q-28.36 0-28.92-28.64V67.44h-14.73V47.66h14.74v-27zM16.39 155.94V68.81H0V47.57h16.39v-9.21q0-18.22 10.64-28.29T56.81 0a70.1 70.1 0 0115 2l-.3 22.44a38.15 38.15 0 00-9-.9q-16.59 0-16.59 15.32v8.71H67.8v21.24H45.92v87.13zM162.43 47.6l.93 12.51q12-14.51 32.3-14.52 17.86 0 26.59 10.12T231.18 86v70h-30V86.65q0-9.21-4.15-13.37t-13.83-4.15q-12.67 0-19 10.41v76.4h-30V47.6z"
});

var SvgLogoPrimary = function SvgLogoPrimary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 511.42 155.94",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoPrimary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoPrimary.b2e75cff.svg";
export { ForwardRef as ReactComponent };